import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";

import AssessmentListItem from "./AssessmentListItem";
import Alert from "../../layouts/Alert";
import Pagination from "../../layouts/Pagination";
import Search from "../../layouts/Search";
import AssessmentFilter from "./AssessmentFilter";
import SortIcon from "../../layouts/SortIcon";
import DeleteConfirmationModal from "../../layouts/DeleteConfirmationModal";
import SelectAllCheckbox from "../../layouts/SelectAllCheckbox";
import { usePersistedTableState } from "../../../hooks/usePersistedTableState";
import { connect } from "react-redux";
import AssessmentAccordion from "../../layouts/AssessmentAccordion";
import { getAssessment, getAssessmentGroup } from "../../../actions/admin";
import { useHistory } from "react-router-dom";
import { loadSchoolsList, setSchool } from "../../../actions/admin";
import PropTypes from "prop-types";
import MultiSelectWithCheckboxes from "../../layouts/MultiSelect";
import { Button } from "react-bootstrap";
import { FILTERS } from "../../../utils/filters";
import FilterControls from "../../layouts/FilterControls";
import Loading from "../../layouts/Loading";

const AssessmentList = ({
  assessmentsList,
  assessmentListLoading,
  showLoader,
  user,
  clearResultList,
  loadSchoolsList,
  setSchool,
  schoolsList,
  schoolListLoading,
  school,
  schoolLoading,
  schoolYears,
  schoolYearsLoading,
  filterData,
  setFilterData,
  handleApplyFilter,
  handleClearFilter,
  filtersApplied,
  showAppliedEffect,
  selectedAssessments,
  setSelectedAssessments,
  searchQuery,
  setSearchQuery,
  persistentFilters,
  page,
  setPage,
  getAssessment,
  getAssessmentGroup,
  selectedTab,
}) => {
  const [listSearch, setListSearch] = useState(assessmentsList);
  const [editViewLoader, setEditViewLoader] = useState(false);
  // const [page, setPage] = useState(1);
  const itemsPerPage = 15;

  const isGrouped = selectedTab !== "assessments";

  const filteredGroups = React.useMemo(() => {
    if (!isGrouped) return [];

    let groups = [...assessmentsList];

    if (searchQuery) {
      const query = searchQuery.toUpperCase();
      groups = groups.filter((group) =>
        (group[0]?.Title || "").toUpperCase().includes(query),
      );
    }

    groups.sort(
      (a, b) => new Date(b[0]?.CreatedDate) - new Date(a[0]?.CreatedDate),
    );

    return groups;
  }, [assessmentsList, searchQuery, isGrouped]);

  const totalCount = isGrouped ? filteredGroups.length : listSearch.length;

  const hist = useHistory();

  // const flattenedAllForRender = isGrouped ? assessmentsList.flat() : listSearch;
  const startForRender = itemsPerPage * (page - 1);
  const endForRender = itemsPerPage * page;
  const visibleItemsForHeader = isGrouped
    ? filteredGroups.slice(startForRender, endForRender).flat()
    : listSearch.slice(startForRender, endForRender);

  const handleGroupEdit = (group) => {
    setEditViewLoader(true);
    const groupItems = group?.allItems?.length ? group.allItems : group?.items;
    if (!groupItems || groupItems.length === 0) return;

    const assessments = groupItems.map((item) => ({
      AssessmentID: item.AssessmentID,
      CategoryID: item.CategoryID,
    }));

    getAssessmentGroup(assessments)
      .then(() => hist.push("/admin/assessment/edit"))
      .finally(() => {
        setEditViewLoader(false);
      });
  };

  const handleGroupView = (group) => {
    setEditViewLoader(true);
    const groupItems = group?.allItems?.length ? group.allItems : group?.items;
    if (!groupItems || groupItems.length === 0) return;

    const assessments = groupItems.map((item) => ({
      AssessmentID: item.AssessmentID,
      CategoryID: item.CategoryID,
    }));

    const first = groupItems[0];

    getAssessmentGroup(assessments)
      .then(() => {
        hist.push(
          `/admin/assessment/assessmentId=${first.AssessmentID}/categoryId=${first.CategoryID}`,
        );
      })
      .finally(() => {
        setEditViewLoader(false);
      });
  };

  const [sortKeys, setSortKeys] = useState([]);

  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    GradeID: "",
    CategoryID: "",
    Title: "",
  });

  const [icons, setIcons] = useState({
    title: 0,
    grade: 0,
    type: 0,
  });

  const [isShowIcon, setIsShowIcon] = useState(null);

  const { title, grade, type } = icons;

  const hasFilters = Object.values(filterData).some((value) =>
    Array.isArray(value) ? value.length > 0 : value,
  );

  const filters = [
    {
      ...FILTERS.school,
      optionsList: schoolsList
        .slice()
        .sort((a, b) => (a?.Name || "").localeCompare(b?.Name || ""))
        .map((school) => ({
          value: school.SchoolID,
          label: school.Name,
        })),
    },
    ...(!isGrouped ? [FILTERS.grade] : [FILTERS.level]),
    ...(isGrouped ? [] : [FILTERS.benchmark]),
    FILTERS.assessment,
  ];

  const isFirstTabRun = useRef(true);

  useEffect(() => {
    if (isFirstTabRun.current) {
      isFirstTabRun.current = false;
      return;
    }
    setFilterData((prev) => ({
      ...prev,
      GradeIDs: [],
      LevelIDs: [],
      BenchMarkIDs: [],
    }));
  }, [selectedTab]);

  useEffect(() => {
    if (user && user.UserTypeID == 5) {
      loadSchoolsList();
    } else {
      loadSchoolsList({ schoolIds: user?.schoolIds });
    }
  }, [user]);

  useEffect(() => {
    if (!assessmentListLoading && assessmentsList && !isGrouped) {
      let updatedList = [...assessmentsList];
      updatedList.sort(
        (a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate),
      );

      if (searchQuery) {
        const query = searchQuery.toUpperCase();
        updatedList = updatedList.filter(
          (asm) =>
            asm.Title.toUpperCase().includes(query) ||
            String(asm.AssessmentID).includes(query),
        );
      }

      setListSearch(updatedList);
    }
  }, [assessmentListLoading, assessmentsList, searchQuery, isGrouped]);
  // useEffect(() => {
  //   if (sortKeys.length > 0) {
  //     setListSearch(
  //       _.orderBy(
  //         searchInput(filterInput(assessmentsList, formData), search),
  //         getKeys(sortKeys),
  //         getOrder(sortKeys),
  //       ),
  //     );
  //   } else {
  //     setListSearch(
  //       searchInput(filterInput(assessmentsList, formData), search),
  //     );
  //   }
  // }, [sortKeys]);

  // useEffect(() => {
  //   if (!assessmentListLoading) {
  //     setListSearch(assessmentsList);
  //   }
  // }, [assessmentListLoading, setListSearch, assessmentsList]);

  const getKeys = (arr) => {
    return arr.map((a) => a.key);
  };
  const getOrder = (arr) => {
    return arr.map((a) => a.order);
  };

  const setFilter = (data) => {
    setIcons({
      title: 0,
      grade: 0,
      type: 0,
    });
    setListSearch(filterInput(listSearch, data));
  };

  const searchInput = (arr, word) => {
    return arr.filter(
      (item) =>
        item.Title.toUpperCase().includes(word.toUpperCase()) ||
        ("Grade " + item.GradeID).toUpperCase().includes(word.toUpperCase()) ||
        item.Category.toUpperCase().includes(word.toUpperCase()),
    );
  };

  const filterInput = (arr, data) => {
    return arr.filter(
      (item) =>
        item.Title.toUpperCase().includes(data.Title.toUpperCase()) &&
        (data.CategoryID === ""
          ? true
          : item.CategoryID + "" === data.CategoryID) &&
        (data.GradeID === "" ? true : item.GradeID + "" === data.GradeID),
    );
  };

  const handleSelectAssessment = (AssessmentID, SchoolID, CategoryID) => {
    setSelectedAssessments((prev) => {
      // Check if the assessment is already selected
      const exists = prev.some((item) => item.AssessmentID === AssessmentID);

      if (exists) {
        // Remove it if it exists
        return prev.filter((item) => item.AssessmentID !== AssessmentID);
      } else {
        // Add the new object if it doesn't
        return [...prev, { AssessmentID, SchoolID, CategoryID }];
      }
    });
  };

  const handleSelectAll = () => {
    if (isGrouped) {
      // When grouped, select/deselect whole groups whose items appear on the current page
      const visibleIds = visibleItemsForHeader.map((a) => a.AssessmentID);
      const groupsToToggle = filteredGroups.filter((group) =>
        group.some((item) => visibleIds.includes(item.AssessmentID)),
      );
      const groupItems = groupsToToggle.flat();
      if (groupItems.length === 0) return;

      const allSelected = groupItems.every((item) =>
        selectedAssessments.some((s) => s.AssessmentID === item.AssessmentID),
      );

      if (allSelected) {
        setSelectedAssessments((prev) =>
          prev.filter(
            (s) => !groupItems.some((g) => g.AssessmentID === s.AssessmentID),
          ),
        );
      } else {
        setSelectedAssessments((prev) => [
          ...prev,
          ...groupItems
            .filter((g) => !prev.some((p) => p.AssessmentID === g.AssessmentID))
            .map((g) => ({
              AssessmentID: g.AssessmentID,
              SchoolID: g.SchoolID,
              CategoryID: g.CategoryID,
            })),
        ]);
      }
    } else {
      // Flat list: toggle visible page items
      const visibleItems = visibleItemsForHeader;
      if (visibleItems.length === 0) return;

      const visibleIds = visibleItems.map((a) => a.AssessmentID);
      const allSelected = visibleIds.every((id) =>
        selectedAssessments.some((s) => s.AssessmentID === id),
      );

      if (allSelected) {
        setSelectedAssessments((prev) =>
          prev.filter((s) => !visibleIds.includes(s.AssessmentID)),
        );
      } else {
        setSelectedAssessments((prev) => [
          ...prev,
          ...visibleItems
            .filter((g) => !prev.some((p) => p.AssessmentID === g.AssessmentID))
            .map((g) => ({
              AssessmentID: g.AssessmentID,
              SchoolID: g.SchoolID,
              CategoryID: g.CategoryID,
            })),
        ]);
      }
    }
  };

  if (editViewLoader) {
    return (
      <div className="d-flex align-items-center h-100 justify-content-center">
        <Loading />
      </div>
    );
  }

  return (
    <div className="card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 users-list ">
      <Alert />

      <div className="d-flex w-100 align-items-center justify-content-between mb-3">
        <div className="">
          {!assessmentListLoading && (
            <Pagination
              totalItems={totalCount} // Total number of items
              itemsPerPage={itemsPerPage} // Number of items per page
              currentPage={page} // Current active page
              onPageChange={setPage} // Callback function to change page
              maxPagesToShow={10} // Maximum number of pages to display (optional)
            />
          )}
        </div>

        <div className="d-flex align-items-center">
          {/* {selectedAssessments.length > 0 && (
            <button
              className="btn btn-danger d-flex align-items-center px-4 me-3"
              data-bs-toggle="modal"
              data-bs-target="#deleteMutipleAssessments"
              // onClick={() => handleBulkDelete(selectedSchools)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash-fill button-child me-2"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5z" />
              </svg>
              Delete ({selectedAssessments.length})
            </button>
          )} */}
          {/* <Search
            setListSearch={setListSearch}
            setSearch={setSearch}
            filter={(e) => {
              setIcons({
                title: 0,
                grade: 0,
                type: 0,
              });

              return searchInput(
                filterInput(assessmentsList, formData),
                e.target.value,
              );
            }}
          /> */}

          <FilterControls
            filters={filters}
            filterData={filterData}
            setFilterData={setFilterData}
            hasFilters={hasFilters}
            filtersApplied={filtersApplied}
            showAppliedEffect={showAppliedEffect}
            handleApplyFilter={handleApplyFilter}
            handleClearFilter={handleClearFilter}
          />
          <Search
            defaultValue={searchQuery}
            filter={(e) => setSearchQuery(e.target.value)}
          />
          {/* <AssessmentFilter
            assessmentsList={assessmentsList}
            setFilter={setFilter}
            setListSearch={setListSearch}
            formData={formData}
            setFormData={setFormData}
            searchInput={searchInput}
            search={search}
          /> */}
          {/* <AssessmentFilter
            formData={filters}
            setFormData={(nextFields) => {
              Object.entries(nextFields).forEach(([key, value]) => {
                updateFilter(key, value);
              });
            }}
            assessmentsList={assessmentsList}
            setListSearch={setListSearch}
          /> */}
        </div>
      </div>
      <div className="admin-users-fields  d-flex align-items-center justify-content-around  rounded  bg-body txt-primary">
        {/* <div className="school-checkbox-column">
          <input
            type="checkbox"
            className={`school-checkbox me-3 form-check-input ${
              listSearch.length > 0 &&
              selectedAssessments.length === listSearch.length
                ? "checkbox-success"
                : ""
            }`}
            checked={
              listSearch.length > 0 &&
              selectedAssessments.length === listSearch.length
            }
            onChange={handleSelectAll}
          />
        </div> */}
        <SelectAllCheckbox
          listSearch={visibleItemsForHeader}
          selectedItems={selectedAssessments}
          handleSelectAll={handleSelectAll}
        />
        {user.UserTypeID === 5 ? (
          <div className="admin-assessments-field text-truncate ">Note</div>
        ) : null}
        <div
          className="admin-assessments-field  text-truncate mx-1 "
          onClick={() => {
            listSearch.forEach((item, id) => {
              let l = listSearch;

              l[id].Title = item.Title.toLowerCase();
              l[id].Category = item.Category.toLowerCase();
              l[id].GradeID = (item.GradeID + "").toLowerCase();

              setListSearch(l);
            });

            if (type === 0) {
              setSortKeys([...sortKeys, { key: "Category", order: "asc" }]);
              setIcons({
                ...icons,
                type: 1,
              });
            } else if (type === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "Category") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                type: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "Category"));
              setIcons({
                ...icons,
                type: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("type")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          Assessment
          <SortIcon icon={type} isShowIcon={isShowIcon === "type"} />
        </div>
        {selectedTab == "assessments" ? (
          <>
            <div className="admin-assessments-field text-truncate ">
              Benchmark
            </div>
            <div
              className="admin-assessments-field  text-truncate mx-1 "
              onClick={() => {
                listSearch.forEach((item, id) => {
                  let l = listSearch;

                  l[id].Title = item.Title.toLowerCase();
                  l[id].Category = item.Category.toLowerCase();
                  l[id].GradeID = (item.GradeID + "").toLowerCase();

                  setListSearch(l);
                });

                if (grade === 0) {
                  setSortKeys([...sortKeys, { key: "GradeID", order: "asc" }]);
                  setIcons({
                    ...icons,
                    grade: 1,
                  });
                } else if (grade === 1) {
                  setSortKeys(
                    sortKeys.map((a) => {
                      if (a.key === "GradeID") return { ...a, order: "desc" };
                      return a;
                    }),
                  );
                  setIcons({
                    ...icons,
                    grade: -1,
                  });
                } else {
                  setSortKeys(sortKeys.filter((a) => a.key !== "GradeID"));
                  setIcons({
                    ...icons,
                    grade: 0,
                  });
                }
              }}
              onMouseEnter={() => setIsShowIcon("grade")}
              onMouseLeave={() => setIsShowIcon(null)}
            >
              Grade
              <SortIcon icon={grade} isShowIcon={isShowIcon === "grade"} />
            </div>
          </>
        ) : (
          <div
            className="admin-assessments-field  text-truncate mx-1 "
            // onClick={() => {
            //   listSearch.forEach((item, id) => {
            //     let l = listSearch;

            //     l[id].Title = item.Title.toLowerCase();
            //     l[id].Category = item.Category.toLowerCase();
            //     l[id].GradeID = (item.GradeID + "").toLowerCase();

            //     setListSearch(l);
            //   });

            //   if (grade === 0) {
            //     setSortKeys([...sortKeys, { key: "GradeID", order: "asc" }]);
            //     setIcons({
            //       ...icons,
            //       grade: 1,
            //     });
            //   } else if (grade === 1) {
            //     setSortKeys(
            //       sortKeys.map((a) => {
            //         if (a.key === "GradeID") return { ...a, order: "desc" };
            //         return a;
            //       }),
            //     );
            //     setIcons({
            //       ...icons,
            //       grade: -1,
            //     });
            //   } else {
            //     setSortKeys(sortKeys.filter((a) => a.key !== "GradeID"));
            //     setIcons({
            //       ...icons,
            //       grade: 0,
            //     });
            //   }
            // }}
            // onMouseEnter={() => setIsShowIcon("grade")}
            // onMouseLeave={() => setIsShowIcon(null)}
          >
            Level
          </div>
        )}
        {selectedTab == "assessments" ? (
          <div
            className="admin-assessments-field text-truncate "
            onClick={() => {
              listSearch.forEach((item, id) => {
                let l = listSearch;
                l[id].Title = item.Title.toLowerCase();
                l[id].Category = item.Category.toLowerCase();
                l[id].GradeID = (item.GradeID + "").toLowerCase();

                setListSearch(l);
              });

              if (title === 0) {
                setSortKeys([...sortKeys, { key: "Title", order: "asc" }]);
                setIcons({
                  ...icons,
                  title: 1,
                });
              } else if (title === 1) {
                setSortKeys(
                  sortKeys.map((a) => {
                    if (a.key === "Title") return { ...a, order: "desc" };
                    return a;
                  }),
                );
                setIcons({
                  ...icons,
                  title: -1,
                });
              } else {
                setSortKeys(sortKeys.filter((a) => a.key !== "Title"));
                setIcons({
                  ...icons,
                  title: 0,
                });
              }
            }}
            onMouseEnter={() => setIsShowIcon("title")}
            onMouseLeave={() => setIsShowIcon(null)}
          >
            Title
            <SortIcon icon={title} isShowIcon={isShowIcon === "title"} />
          </div>
        ) : null}

        <div className="admin-assessments-field text-truncate ml-1">
          Actions
        </div>
      </div>
      <div className="users-list-body ">
        {showLoader ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border txt-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : isGrouped ? (
          (() => {
            const start = itemsPerPage * (page - 1);
            const end = itemsPerPage * page;
            const pageGroups = filteredGroups.slice(start, end);

            const groupsToRender = pageGroups.map((group, idx) => {
              const selected = group.length
                ? group.every((g) =>
                    selectedAssessments.some(
                      (s) => s.AssessmentID === g.AssessmentID,
                    ),
                  )
                : false;
              return {
                id: start + idx,
                title: group[0]?.Title,
                items: group,
                selected,
                allItems: group,
              };
            });

            const handleGroupSelectLocal = (group) => {
              const groupItems = group.allItems || group.items || [];
              if (groupItems.length === 0) return;
              const allSelected = groupItems.every((item) =>
                selectedAssessments.some(
                  (s) => s.AssessmentID === item.AssessmentID,
                ),
              );
              if (allSelected) {
                setSelectedAssessments((prev) =>
                  prev.filter(
                    (s) =>
                      !groupItems.some(
                        (g) => g.AssessmentID === s.AssessmentID,
                      ),
                  ),
                );
              } else {
                setSelectedAssessments((prev) => [
                  ...prev,
                  ...groupItems
                    .filter(
                      (g) =>
                        !prev.some((p) => p.AssessmentID === g.AssessmentID),
                    )
                    .map((g) => ({
                      AssessmentID: g.AssessmentID,
                      SchoolID: g.SchoolID,
                      CategoryID: g.CategoryID,
                    })),
                ]);
              }
            };

            return (
              <AssessmentAccordion
                groups={groupsToRender}
                renderItem={(assessment) => (
                  <AssessmentListItem
                    assessment={assessment}
                    key={assessment.AssessmentID}
                    user={user}
                    selectedAssessments={selectedAssessments}
                    handleSelectAssessment={handleSelectAssessment}
                  />
                )}
                user={user}
                onGroupEdit={handleGroupEdit}
                onGroupView={handleGroupView}
                onGroupSelect={handleGroupSelectLocal}
              />
            );
          })()
        ) : (
          listSearch
            .slice(15 * (page - 1), 15 * page)
            .map((assessment, id) => (
              <AssessmentListItem
                assessment={assessment}
                key={id}
                user={user}
                selectedAssessments={selectedAssessments}
                handleSelectAssessment={handleSelectAssessment}
              />
            ))
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  user: state.auth.user,
  schoolsList: state.admin.schoolsList,
  schoolListLoading: state.admin.schoolListLoading,
  school: state.admin.school,
  schoolLoading: state.admin.schoolLoading,
  schoolYears: state.admin.schoolYears,
  schoolYearsLoading: state.admin.schoolYearsLoading,
});

export default connect(mapStateToProps, {
  loadSchoolsList,
  setSchool,
  getAssessment,
  getAssessmentGroup,
})(AssessmentList);
